const e=e=>`org:${e}`,t=(e,t)=>`org:${e}:user:${t}`;export{e as constructOrgTargetId,t as constructOrgUserTargetId};
//# sourceMappingURL=atomic.mjs.map